import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRouter } from '@24i/nxg-core-router/src/NextRouter';
import SingleRow from '@24i/nxg-sdk-gluons/src/components/containers/SingleRow/index.web';
import getSingleRowStyles from '@24i/nxg-sdk-gluons/src/components/containers/SingleRow/styles/index.web';
import Packshot from '@24i/nxg-sdk-gluons/src/components/ui/Packshot/index.web';
import getPackshotStyles from '@24i/nxg-sdk-gluons/src/components/ui/Packshot/styles/index.web';
import { useTheme } from '@24i/nxg-sdk-higgs';
import { SOTT_DEFAULT_WEB_SCREENS } from '@24i/nxg-sdk-smartott/src/navigation/constants';
import { modalType } from '@24i/player-ui';
import { CloseButton } from '../../components/CloseButton';
import { Container, PackshotHolder } from './styled';
const PACKSHOT_WIDTH = 248;
const PACKSHOT_HEIGHT = 139;
export const RelatedModal = ({ className = '', relatedItems, }) => {
    const router = useRouter();
    const { theme } = useTheme();
    const { t } = useTranslation(['sott']);
    const handleItemPress = (asset, event) => {
        if (event.preventDefault)
            event.preventDefault();
        if (event.stopPropagation)
            event.stopPropagation();
        const { type, id } = asset;
        const assetLink = SOTT_DEFAULT_WEB_SCREENS.Playback.getLink({
            type,
            id,
        });
        router.replace({
            pathname: assetLink.href,
        }, assetLink.as);
    };
    const renderPackshot = (props) => {
        var _a;
        return (React.createElement(PackshotHolder, null,
            React.createElement(Packshot, Object.assign({}, props, { styles: (propsTheme) => {
                    const packshotStyles = getPackshotStyles(propsTheme);
                    return Object.assign(Object.assign({}, packshotStyles), { item: Object.assign(Object.assign({}, packshotStyles.item), { overflow: 'visible' }) });
                }, actionIcon: "play", title: props.item.title, subtitle: (_a = props.item.subtitle) !== null && _a !== void 0 ? _a : '' }))));
    };
    return (React.createElement(Container, { className: `Related-Modal ${className}` },
        React.createElement(CloseButton, { type: modalType.related }),
        React.createElement(SingleRow, { onItemPress: handleItemPress, title: t('player.miniEpg.allRelated'), packshotHeight: PACKSHOT_HEIGHT, packshotWidth: PACKSHOT_WIDTH, key: "relatedAssetsRow", section: { items: relatedItems }, styles: (propsTheme) => {
                const singleRowStyles = getSingleRowStyles(propsTheme);
                return Object.assign(Object.assign({}, singleRowStyles), { container: Object.assign(Object.assign({}, singleRowStyles.container), { width: '100%', marginHorizontal: 'auto', overflow: 'visible' }) });
            }, textColor: theme.color.textSecondary, renderPackshot: renderPackshot })));
};
//# sourceMappingURL=index.js.map